import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import dayjs from 'dayjs';
import {
  getUserSubscription,
  hasActiveOwnSubscription,
} from '../../../framework/constants/subscription.constants';
import { SubscriptionService } from '../../../services/subscription.service';
import { NotificationsService } from '../../../services/notifications.service';
import { CurrentUserService } from '../../../services/current-user.service';
import { User } from '../../../framework/constants/user.constants';
import { SimpleButtonComponent } from '@app/framework/buttons/simple-medium-button/simple-button.component';

@Component({
  selector: 'app-subscribe',
  imports: [CommonModule, FormsModule, SimpleButtonComponent],
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit, OnDestroy {
  triggerAnimation = false;
  user: User;
  hasEndedTrial = false;
  isUserInfoLoading = true;
  subscriptionEnded = false;
  hasTeamSubscription = false;

  isDestroyed$ = new Subject();

  constructor(
    private subscriptionService: SubscriptionService,
    private notif: NotificationsService,
    private userService: CurrentUserService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.subscribeToUserUpdates();
  }

  subscribeToUserUpdates() {
    this.isUserInfoLoading = true;
    this.notif.showLoading();
    this.userService.data$.pipe(takeUntil(this.isDestroyed$)).subscribe((user) => {
      this.isUserInfoLoading = false;
      this.notif.close();
      if (!user) {
        this.notif.showError('An error occurred: could not retrieve user data.');
        return;
      }
      this.user = user;

      this.hasTeamSubscription = !!getUserSubscription(user)?.isTeamSubscription;

      if (!user.subscription) {
        return;
      }

      if (hasActiveOwnSubscription(user)) {
        this.router.navigate(['webapp']);
        return;
      }

      const trialEnd = dayjs(user.subscription.trial_ends_at);
      if (user.subscription.status === 'trialing' && trialEnd.isBefore(dayjs())) {
        this.hasEndedTrial = true;
      }

      if (dayjs(user.subscription.ends_at).isBefore(dayjs())) {
        this.subscriptionEnded = true;
      }
    });
  }

  goBack() {
    this.router.navigate(['webapp']);
  }

  logout() {
    this.userService.logout();
    this.router.navigate(['auth', 'login']);
  }

  manageSubscription() {
    this.triggerAnimation = true;
    this.subscriptionService.openCustomerPortal();
  }

  protected openCheckoutPage() {
    this.triggerAnimation = true;
    this.subscriptionService.openCheckoutPage().subscribe();
  }

  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }
}
